// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.private-success-container {
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  max-height: 60vh;
}

.info-card {
  margin: 0;
}

.password-button-container {
  margin: 25px 0;
}

.next-step-container-title {
  font-weight: bold;
  text-align: left;
}

.phone-container {
  text-align: center;
  margin: 20px 0 20px 0;
}
.phone-container .phone-img {
  display: block;
  margin: 0 auto;
}

.store-container {
  min-height: 45px;
  margin: 10px 0;
}
.store-container .apple-container {
  height: 44px;
  width: 50%;
  float: left;
  padding-right: 20px;
}
.store-container .apple-container .apple-store-img {
  display: block;
  margin: 0;
  margin-left: auto;
}
.store-container .play-container {
  height: 44px;
  float: left;
  width: 50%;
}
.store-container .play-container .play-store-img {
  margin: 0;
}

.gray-text {
  text-align: right;
  font-weight: 400;
}

.info-account-txt {
  text-align: left;
}

.green-text {
  margin: 15px 0;
  font-weight: bold;
}

.account-info-container, .info-container {
  font-size: 14px;
  border: 0.5px solid #C9D4DF;
  border-radius: 8px;
  padding: 1.7em;
  margin: 2em 0 2em 0;
  max-height: 16em;
  position: relative;
}

.account-info-container {
  color: #44474B;
}
.account-info-container > div:nth-of-type(3) {
  padding-top: 15px;
}
.account-info-container .omni-1-gray-text {
  font-weight: 600;
}

.info-container .info-img {
  display: block;
  margin: 0 auto;
}
.info-container .txt_info_1 {
  font-size: 15px;
  font-weight: 600;
  text-align: center;
}
.info-container label {
  font-size: 15px !important;
}

.copy-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0 !important;
}
.copy-button-container .btn-cci, .copy-button-container .btn-cci:hover {
  width: 100%;
  color: #fff;
  background-color: #585D61;
  border-color: #585D61;
}

.tips {
  text-align: justify;
}

.tip-container .number-tip {
  float: left;
  background-color: #38A121;
  width: 25px;
  border-radius: 50%;
  text-align: center;
  color: #fff;
}
.tip-container > label {
  display: block;
  margin-left: 40px;
  margin-top: 22px;
}

.form-group-button {
  margin-top: 35px;
}
.form-group-button > button {
  padding: 0;
}

label {
  margin: 10px 0;
}

.copy-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
  margin-left: 5px;
  padding: 3px;
  border-radius: 4px;
}

.wc-container .wc-container-in {
  /* .wc-container-inner {
    overflow-y: scroll;
    max-height: 60vh;
    overflow-x: hidden;
  } */
}
.wc-container .wc-container-in .account-info-container {
  text-align: left;
}
.wc-container .wc-container-in .form-group-button {
  margin: 0;
}
.wc-container .wc-container-in .information-container {
  margin-bottom: 0;
}
.wc-container .wc-container-in .info-card {
  margin: 0;
}

@media (max-width: 380px) {
  .store-container {
    min-height: 115px;
  }
  .store-container .apple-container {
    width: 100%;
    float: none;
    margin-bottom: 25px;
    padding-right: 0px;
  }
  .store-container .apple-container .apple-store-img {
    display: block;
    margin: 0 auto;
  }
  .store-container .play-container {
    float: none;
    width: 100%;
  }
  .store-container .play-container .play-store-img {
    display: block;
    margin: 0 auto;
  }
}
a.green-text {
  font-size: 15px;
  font-family: "PFBeauSansPro", sans-serif;
  text-align: left;
  cursor: pointer;
  font-weight: bold;
  color: #2B8F14;
}
a.green-text .arrow-green {
  background-image: url("https://static-qa.fif.tech/onboarding-peru-cuentas-assets/accounts/assets/icons/generic/arrow-up-right-green.svg");
  background-repeat: no-repeat;
  display: inline-block;
  height: 20px;
  width: 15px;
  margin-top: 0px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
